export default __webpack_public_path__ + "static/media/bg0_m.e4d69732.png";